import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

import { observable, makeObservable, runInAction, computed } from "mobx";
import BrandRules from "../../utils/BrandRules";
var BreadSticksModel = (_class = /*#__PURE__*/function () {
  function BreadSticksModel() {
    _classCallCheck(this, BreadSticksModel);

    _initializerDefineProperty(this, "_cartItems", _descriptor, this);

    _initializerDefineProperty(this, "_checkDetailItems", _descriptor2, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor3, this);

    _initializerDefineProperty(this, "_isBreadCountEnabled", _descriptor4, this);

    makeObservable(this);
  }

  _createClass(BreadSticksModel, [{
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "isBreadCountEnabled",
    get: function get() {
      return this._isBreadCountEnabled;
    },
    set: function set(_isBreadCountEnabled) {
      var _this2 = this;

      runInAction(function () {
        _this2._isBreadCountEnabled = _isBreadCountEnabled;
      });
    }
  }, {
    key: "cartItems",
    get: function get() {
      return this._cartItems;
    },
    set: function set(_cartItems) {
      var _this3 = this;

      runInAction(function () {
        _this3._cartItems = _cartItems;
      });
    }
  }, {
    key: "checkDetailItems",
    get: function get() {
      return this._checkDetailItems;
    },
    set: function set(_checkDetailItems) {
      var _this4 = this;

      runInAction(function () {
        _this4._checkDetailItems = _checkDetailItems;
      });
    }
  }, {
    key: "checkDetailBreadStickItems",
    get: function get() {
      var result = [];

      if (this.checkDetailItems) {
        var _this$checkDetailItem, _this$checkDetailItem2;

        (_this$checkDetailItem = this.checkDetailItems) === null || _this$checkDetailItem === void 0 ? void 0 : (_this$checkDetailItem2 = _this$checkDetailItem.packagingItem) === null || _this$checkDetailItem2 === void 0 ? void 0 : _this$checkDetailItem2.forEach(function (item) {
          var breadCount = parseInt(item.quantity, 10);
          var displayName = breadCount === 1 ? item.name.replace(/s$/, "") : item.name;

          if (item.name.toLowerCase().includes("extra stick")) {
            var product = "Breadsticks";
            var productType = breadCount === 1 ? product.replace(/s$/, "") : product;
            displayName = "Extra ".concat(productType);
          }

          if (breadCount > 0 && (displayName.toLowerCase().includes("stick") || displayName.toLowerCase().includes("croissant"))) {
            result.push({
              breadCount: breadCount,
              displayName: displayName
            });
          }
        });
      }

      return result;
    }
  }, {
    key: "totalBreadCount",
    get: function get() {
      var breadStickItems = this.breadStickItems;
      var total = 0;

      if (breadStickItems) {
        breadStickItems.forEach(function (item) {
          total += item.breadCount;
        });
      }

      return total;
    }
  }, {
    key: "breadStickItems",
    get: function get() {
      var result = [];

      if (this.cartItems) {
        this.cartItems.forEach(function (item) {
          var breadCount = parseInt(item.breadCount, 10);
          var displayName = item.displayName;

          if (breadCount > 0) {
            result.push({
              breadCount: item.quantity * breadCount,
              displayName: displayName,
              quantity: item.quantity
            });
          }

          if (item.subItem) {
            item.subItem.forEach(function (sItem) {
              var subItemBreadCount = parseInt(sItem.breadCount, 10);
              var subItemDisplayName = sItem.configOptionName || sItem.displayName;

              if (subItemBreadCount > 0) {
                result.push({
                  breadCount: item.quantity * subItemBreadCount,
                  displayName: subItemDisplayName,
                  quantity: item.quantity
                });
              }
            });
          }
        });
      }

      return result;
    }
  }, {
    key: "brandSpecificProduct",
    get: function get() {
      var _this$_appAttributes;

      return new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode).brandSpecificProduct();
    }
  }, {
    key: "brandCode",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      return this === null || this === void 0 ? void 0 : (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.concept) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.conceptCode;
    }
  }, {
    key: "breadSticksCateringLink",
    get: function get() {
      var _this$_appAttributes4, _this$_appAttributes5;

      return (this === null || this === void 0 ? void 0 : (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.breadCountUpsellUrlCatering) || "";
    }
  }, {
    key: "breadSticksTogoLink",
    get: function get() {
      var _this$_appAttributes6, _this$_appAttributes7;

      return (this === null || this === void 0 ? void 0 : (_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.configs) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.breadCountUpsellUrlTogo) || "";
    }
  }]);

  return BreadSticksModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_cartItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_checkDetailItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_isBreadCountEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isBreadCountEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBreadCountEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkDetailItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkDetailItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkDetailBreadStickItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkDetailBreadStickItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalBreadCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalBreadCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "breadStickItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "breadStickItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "brandSpecificProduct", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "brandSpecificProduct"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "brandCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "brandCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "breadSticksCateringLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "breadSticksCateringLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "breadSticksTogoLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "breadSticksTogoLink"), _class.prototype)), _class);
export { BreadSticksModel as default };